import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showError, loginWithSiteAppId } from "../../redux/common/actions";
import ConfirmDialog from 'components/Elements/ConfirmDialog';

export const withSiteAppSwitching = (WrappedComponent) => {
    return function WithSiteAppSwitchingComponent(props) {
        const dispatch = useDispatch();
        const { t } = useTranslation();
        const [showSwitchDialog, setShowSwitchDialog] = useState(false);
        const [targetSiteAppId, setTargetSiteAppId] = useState(null);

        // Get user data from storage
        const userData = JSON.parse(localStorage.getItem("me")) ||
            JSON.parse(sessionStorage.getItem("me"));
        
        const currentSiteAppId = userData?.siteAppID?.toString();

        useEffect(() => {
            const urlParams = new URLSearchParams(window.location.search);
            const urlSiteAppId = urlParams.get("siteAppId");
            
            // Only show dialog if there's a siteAppId mismatch
            if (urlSiteAppId && currentSiteAppId !== urlSiteAppId) {
                setTargetSiteAppId(urlSiteAppId);
                setShowSwitchDialog(true);
            }
        }, [currentSiteAppId]);

        const switchSiteApp = async () => {
            try {
                await dispatch(loginWithSiteAppId(targetSiteAppId));
            } catch (error) {
                dispatch(showError(t("message.accessDeniedNoPermission")));
            }
        };

        const handleConfirmSwitch = () => {
            if (targetSiteAppId) {
                switchSiteApp();
            }
            setShowSwitchDialog(false);
        };

        const handleCancelSwitch = () => {
            setShowSwitchDialog(false);
            setTargetSiteAppId(null);
            
            // Redirect back to current siteAppId
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set("siteAppId", currentSiteAppId);
            window.location.href = newUrl.toString();
        };

        return (
            <>
                <ConfirmDialog
                    open={showSwitchDialog}
                    title={t("title.switchSiteApplication")}
                    message={t("message.switchSiteApplicationConfirm")}
                    confirmButtonText={t("action.switch")}
                    onConfirm={handleConfirmSwitch}
                    onCancel={handleCancelSwitch}
                />
                <WrappedComponent {...props} />
            </>
        );
    };
}; 